<template>
  <div>
    <el-table :data="resultList" max-height="250">
      <el-table-column width="100" label="序号" align="center" type="index" />
      <el-table-column
        label="标题"
        align="center"
        prop="bt"
        show-overflow-tooltip
      />
      <el-table-column width="180" label="时间" align="center" prop="gxsj" />
      <el-table-column
        width="100"
        label="操作"
        align="center"
        class-name="small-padding fixed-width"
      >
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="text"
            icon="el-icon-edit"
            @click="openDialog(scope.row.id)"
          >
            详情
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <pagination
      v-show="total > 0"
      :total="total"
      :page.sync="queryParams.pageNum"
      :limit.sync="queryParams.pageSize"
      @pagination="getInfoList"
    />
    <!--    弹框-->
    <div id="dialog">
      <el-dialog
        width="80%"
        title="水位公告"
        center
        @close="closeDialog()"
        v-if="isShow"
        :visible.sync="isShow"
        append-to-body
        :destroy-on-close="true"
        style="top: 115px; left: 130px"
      >
        <!--        显示内容容器-->
        <div id="html_container" style="width: 100%; height: 100%" />
      </el-dialog>
    </div>
  </div>
</template>
<script>
import axios from "axios";
export default {
  props: ["isToken"],
  data() {
    return {
      resultList: [],
      BASE_URL: "http://cctv.hbrytech.cn:2123/prod-api/",
      isShow: false,
      total: 0,
      queryParams: {
        pageNum: 1,
        pageSize: 10,
      },
    };
  },
  created() {},
  methods: {
    // 水位公告
    getInfoList() {
      console.log(this.isToken, "isTokenisToken");
      axios({
        url: this.$root.BASE_URL + "/work/notice/wwlfr",
        method: "get",
        params: this.queryParams,
        headers: {
          authorization: this.isToken,
        },
      }).then((res) => {
        console.log(res, "123456");
        this.resultList = res.data.rows;
        this.total = res.data.total;
      });
    },
    openDialog(id) {
      // 开启弹框
      this.isShow = true;
      this.$nextTick(() => {
        // 请求后端获取 详细内容
        axios({
          url: this.$root.BASE_URL + `/work/notice/wwlfr/${id}`,
          method: "get",
          headers: {
            authorization: this.isToken,
          },
        }).then((res) => {
          let dialogDom = document.querySelector("#html_container");
          dialogDom.insertAdjacentHTML("afterbegin", res.data.data.nr);
        });
      });
    },
    // closeDialog() {
    //   // 关闭弹框
    //   this.isShow = false;
    // },
  },
};
</script>
<style>
.el-dialog {
  /* 添加边框样式 */
  border: 10px solid #43b1d3; /* 你可以设置你想要的边框样式 */
  border-radius: 4px; /* 可选：添加边框圆角 */
}
.el-dialog__header {
  background-color: #e1e6ed;
}
.el-dialog__title {
  font-weight: 800;
}
</style>
